module.exports = "<p>\r\n  shared works!\r\n</p>\r\n"